import { useState } from "react";

import { RegulatoryListData } from "@/components/business/RegulatoryContainer/Regulatory.types";
import { ProcessStatusCode } from "@/types/code.types";
import Modal from "@atoms/Modal/Modal";
import IconAlert from "@images/pressList/statusModal/icon-alert-red.svg";
import IconClose from "@images/pressList/statusModal/icon-close.svg";
import { DRAFT_STATUS_INFO } from "@PressListContainer/draftStatusInfo.constants";

import * as S from "./RegulatoryCheckStatusGuide.style";
import { useMoveRegulatoryDetailPage } from "../../hooks/useMoveRegulatoryDetailPage";

interface Props {
  regulatoryData: RegulatoryListData;
  closeModal: () => void;
  updateRegulatoryList: () => void;
  currentStatus: ProcessStatusCode | "";
}

const RegulatoryCheckStatusGuide = ({
  regulatoryData,
  closeModal,
  updateRegulatoryList,
  currentStatus,
}: Props) => {
  const [initPressStatus] = useState(regulatoryData?.draftArticleStatusHighest);

  const { moveRegulatoryDetailPage } = useMoveRegulatoryDetailPage({
    draftArticleId: regulatoryData?.draftArticleId?.toString(),
    labelId: regulatoryData?.labelId,
  });

  const handleCancelEvent = () => {
    updateRegulatoryList();
    closeModal();
  };

  return (
    <Modal closeModal={closeModal}>
      <S.ModalContentsWrapper>
        <S.ModalTitle>
          <img src={IconAlert} alt="" />
          Status Change Notification
        </S.ModalTitle>
        <S.ModalText>
          The status of the selected Press has been changed from ‘
          <strong>
            {initPressStatus && DRAFT_STATUS_INFO[initPressStatus].text}
          </strong>
          ’ to ‘
          <strong>
            {currentStatus && DRAFT_STATUS_INFO[currentStatus].text}
          </strong>
          ’. Would you like to continue?
        </S.ModalText>
        <S.ModalButtonWrapper>
          <S.CancelButton type="button" onClick={handleCancelEvent}>
            Back to Regulatory Label List
          </S.CancelButton>
          <S.RefreshButton type="button" onClick={moveRegulatoryDetailPage}>
            Continue
          </S.RefreshButton>
          <S.CloseButton type="button" onClick={handleCancelEvent}>
            <img src={IconClose} alt="Close" />
          </S.CloseButton>
        </S.ModalButtonWrapper>
      </S.ModalContentsWrapper>
    </Modal>
  );
};

export default RegulatoryCheckStatusGuide;
